import { createAction } from "@reduxjs/toolkit";
import {
    GET_RESTRICTIONS,
    GET_SUB_RESTRICTIONS,
    GET_TIME_LIMIT_VALUES,
    PUT_SUB_ACTIVITY_DATA,
    RESTRICTIONS_RECEIVED,
    SET_GLOBAL_FILTERS,
    SET_GLOBAL_FILTERS_FOR_PFCV,
    SET_TIME_LIMIT_FILTER,
    SUB_ACTIVITY_DATA_RECEIVED,
    SUB_RESTRICTIONS_RECEIVED,
    TIME_LIMIT_VALUES_RECEIVED,
    TOGGLE_RESET_BUTTON,
    GetRestrictions,
    RestrictionReceived,
    GetSubRestrictions,
    SubRestrictionReceived,
    SubActivityDataReceived,
    SetGlobalFilters,
    SetGlobalFiltersForPFCV,
    PutSubActivityData,
    ToggleResetButton,
    TimeLimitValuesReceived,
    SetTimeLimitFilter,
    PUT_OCCUPANCY_DATA,
    PutOccupancyData,
    GetPermitParkingValues,
    GET_PERMIT_PARKING_VALUES,
    PermitParkingValuesReceived,
    PERMIT_PARKING_VALUES_RECEIVED,
    SelectedPermitParkingValues,
    SELECTED_PERMIT_VALUES,
    STORE_PERMIT_LINKS_AND_SUBRESTRICTION_IDS,
    StorePermitsData,
    STORE_PERMITS_DATA,
    StorePermitLinksAndSubRestrictionIds,
    StorePricetLinksAndSubRestrictionIds,
    STORE_PRICE_LINKS_AND_SUBRESTRICTION_IDS,
    GET_PERMIT_DATA_VALUES,
    SelectedPriceValues,
    SELECTED_PRICE_VALUES,
    GetPermitDataValues,
    STORE_USER_CLASS_CATEGORY_VALUES,
    StoreUserClassCategoryValues,
    StorePricedata,
    STORE_PRICE_DATA,
    GetPriceDataValues,
    GET_PRICE_DATA_VALUES
} from "./types";

export const getRestrictions = createAction<GetRestrictions["payload"]>(GET_RESTRICTIONS);

export const restrictionReceived =
    createAction<RestrictionReceived["payload"]>(RESTRICTIONS_RECEIVED);

export const getSubRestrictions = createAction<GetSubRestrictions["payload"]>(GET_SUB_RESTRICTIONS);

export const subRestrictionReceived =
    createAction<SubRestrictionReceived["payload"]>(SUB_RESTRICTIONS_RECEIVED);

export const subActivityDataReceived = createAction<SubActivityDataReceived["payload"]>(
    SUB_ACTIVITY_DATA_RECEIVED
);

export const setGlobalFilters = createAction<SetGlobalFilters["payload"]>(SET_GLOBAL_FILTERS);

export const setGlobalFiltersForPFCV = createAction<SetGlobalFiltersForPFCV["payload"]>(
    SET_GLOBAL_FILTERS_FOR_PFCV
);

export const putSubActivityData =
    createAction<PutSubActivityData["payload"]>(PUT_SUB_ACTIVITY_DATA);

export const putOccupancyData = createAction<PutOccupancyData["payload"]>(PUT_OCCUPANCY_DATA);

export const toggleResetButton = createAction<ToggleResetButton["payload"]>(TOGGLE_RESET_BUTTON);

export const getTimeLimitValues = createAction(GET_TIME_LIMIT_VALUES);

export const timeLimitValuesReceived = createAction<TimeLimitValuesReceived["payload"]>(
    TIME_LIMIT_VALUES_RECEIVED
);

export const setTimeLimitFilter =
    createAction<SetTimeLimitFilter["payload"]>(SET_TIME_LIMIT_FILTER);

export const getPermitParkingValues =
    createAction<GetPermitParkingValues["payload"]>(GET_PERMIT_PARKING_VALUES);

export const getPermitDataValues =
    createAction<GetPermitDataValues["payload"]>(GET_PERMIT_DATA_VALUES);

export const storeUserClassCategoryValues = createAction<StoreUserClassCategoryValues["payload"]>(
    STORE_USER_CLASS_CATEGORY_VALUES
);

export const permitParkingValuesReceived = createAction<PermitParkingValuesReceived["payload"]>(
    PERMIT_PARKING_VALUES_RECEIVED
);

export const storeSelectedPermitValues =
    createAction<SelectedPermitParkingValues["payload"]>(SELECTED_PERMIT_VALUES);

export const storePermitLinksAndSubRestrictionIds = createAction<
    StorePermitLinksAndSubRestrictionIds["payload"]
>(STORE_PERMIT_LINKS_AND_SUBRESTRICTION_IDS);

export const storePermitsData = createAction<StorePermitsData["payload"]>(STORE_PERMITS_DATA);

export const getPriceLimitData = createAction<GetPriceDataValues["payload"]>(GET_PRICE_DATA_VALUES);

export const storePriceData = createAction<StorePricedata["payload"]>(STORE_PRICE_DATA);

export const storeSelectedPriceValues =
    createAction<SelectedPriceValues["payload"]>(SELECTED_PRICE_VALUES);

export const storePriceLinksAndSubRestrictionIds = createAction<
    StorePricetLinksAndSubRestrictionIds["payload"]
>(STORE_PRICE_LINKS_AND_SUBRESTRICTION_IDS);
